import { rest } from 'msw';
import { AGENTS_API_URL } from '../../config';
import { generateConversationFaker } from '../fixtures/chat.faker';

let globalChatState = Array.from({ length: 10 }, () => generateConversationFaker());

const updateGlobalChatStateTitle = (id: string, title: string) => {
    globalChatState.forEach((item) => {
        if (item._id === id) {
            item.title = title;
        }
    });
};

const deleteGlobalChatStateItem = (id: string) => {
    globalChatState = globalChatState.filter((item) => item._id !== id);
};

export const chatHandler = [
    rest.get(AGENTS_API_URL + '/conversations/search', (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json(globalChatState),
        );
    }),
    rest.get(AGENTS_API_URL + '/conversations/:conversationId', (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json({ ...generateConversationFaker(), _id: req.params['conversationId'] }),
        );
    }),
    rest.patch(AGENTS_API_URL + '/conversations/:conversationId', (req, res, ctx) => {
        const body = req.body as { title?: string }; // Explicitly type req.body
        const id = req.params['conversationId'] as string; // Explicitly type req.params._id
        const conversation = globalChatState.find((item) => item._id === id);
        updateGlobalChatStateTitle(id, body.title ?? (conversation?.title as string));
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json(conversation),
        );
    }),
    rest.delete(AGENTS_API_URL + '/conversations/:conversationId', (req, res, ctx) => {
        deleteGlobalChatStateItem(req.params['conversationId'] as string);
        return res(
            // Respond with a 200 status code
            ctx.status(200),
        );
    }),
];
